// import questionsConfig from '../../../static/questions_config.js'
// let questionsConfig = require('../../../static/questions_config')

// initial state
const state = {
  allQuestions: [],
  selectedQuestions: [],
  selectedTopics: [],
  presentation_mode: 0,
  language: 'de',
  correct_answered: 0,
  display_config: true
}

// getters
const getters = {
  allQuestions: state => state.allQuestions,

  getAllTopics: (state) => {
    let topics = []
    state.allQuestions.filter(function (item) {
      item[state.language].topics.forEach(topic => {
        if (!topics.includes(topic)) topics.push(topic)
        return null
      })
    })
    return topics
  },
  getSelectedQuestions: (state) => state.selectedQuestions,
  getSelectedTopics: (state) => state.selectedTopics,
  getPresentationMode: (state) => state.presentation_mode,
  getCorrectAnswered: (state) => state.correct_answered,
  getDisplayConfig: (state) => state.display_config,
  getLanguage: (state) => state.language
}

// actions
const actions = {
  setAllQuestions ({ commit }, questions) {
    commit('setAllQuestions', questions)
  },
  setSelectedQuestions ({commit}) {
    let questions = []
    state.allQuestions.forEach(function (Question) {
      let questionIn = false
      Question[state.language].topics.forEach(topicQuestion => {
        if (state.selectedTopics.includes(topicQuestion)) questionIn = true
      })
      if (questionIn) questions.push(Question[state.language])
    })
    commit('setSelectedQuestions', questions)
  },
  setSelectedTopics ({commit}, value) {
    commit('setSelectedTopics', value)
  },
  setDisplayConfig ({commit}, value) { commit('setDisplayConfig', value) },
  setLanguage ({commit}, value) { commit('setLanguage', value) },
  setPresentationMode ({commit}, value) { commit('setPresentationMode', value) },
  incrementCorrectCount ({commit}) { commit('incrementCorrectCount') },
  resetCorrectAnsweredCount ({commit}) { commit('resetCorrectAnsweredCount') }
}

// mutations
const mutations = {
  setAllQuestions (state, questions) {
    state.allQuestions = questions
  },
  setSelectedTopics (state, topicsSelected) {
    state.selectedTopics = topicsSelected
  },
  setSelectedQuestions (state, questions) {
    state.selectedQuestions = questions
  },
  setDisplayConfig (state, displayConfig) {
    state.display_config = displayConfig
  },
  setLanguage (state, language) {
    state.language = language
  },
  setPresentationMode (state, presentationMode) {
    state.presentation_mode = presentationMode
  },
  incrementCorrectCount (state) {
    state.correct_answered++
  },
  resetCorrectAnsweredCount (state) {
    state.correct_answered = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/questions.js